"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeriesNonceManagerPredicateBuilder = void 0;
const series_nonce_manager_model_1 = require("./model/series-nonce-manager.model");
const abstract_predicate_builder_1 = require("./utils/abstract-predicate-builder");
const limit_order_protocol_const_1 = require("./limit-order-protocol.const");
const series_nonce_manager_utils_1 = require("./utils/series-nonce-manager.utils");
/**
 * All methods is lambdas to preserve `this` context and allow DSL-like usage
 */
class SeriesNonceManagerPredicateBuilder extends abstract_predicate_builder_1.AbstractPredicateBuilder {
    constructor() {
        super(...arguments);
        this.nonce = (series, makerAddress) => {
            series_nonce_manager_utils_1.assertSeries(series);
            return this.facade.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.nonce, [series, makerAddress]);
        };
        this.nonceEquals = (series, makerAddress, makerNonce) => {
            series_nonce_manager_utils_1.assertSeries(series);
            return this.facade.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.nonceEquals, [series, makerAddress, makerNonce]);
        };
        this.timestampBelowAndNonceEquals = (series, timestamp, makerNonce, makerAddress) => {
            series_nonce_manager_utils_1.assertSeries(series);
            const predicateValue = BigInt(makerAddress)
                + (BigInt(series) << BigInt(160))
                + (BigInt(makerNonce) << BigInt(160 + 16))
                + (BigInt(timestamp) << BigInt(160 + 16 + 40));
            return this.facade.getContractCallData(series_nonce_manager_model_1.SeriesNonceManagerMethods.timestampBelowAndNonceEquals, [limit_order_protocol_const_1.ZX + predicateValue.toString(16)]);
        };
    }
}
exports.SeriesNonceManagerPredicateBuilder = SeriesNonceManagerPredicateBuilder;
//# sourceMappingURL=series-nonce-manager-predicate.builder.js.map